<template>

  <BasicLayout>
    <FederationInfos :federation="federation" :loading="loadingInfos"></FederationInfos>
    <FederationCategories class="block" :categories="categories" :loading="loadingCategories" :federationID="federation.id"></FederationCategories>
    <FederationRegions class="block" :regions="regions" :loading="loadingRegions"></FederationRegions>
    <v-snackbar v-model="snackbar" color="error" :timeout="5000">{{ errorMessage }}</v-snackbar>
  </BasicLayout>

</template>

<script>

import BasicLayout from '@/layouts/BasicLayout'
import FederationInfos from './FederationInfos'
import FederationCategories from './FederationCategories'
import FederationRegions from './FederationRegions'

export default {
  name: 'FederationPage',
  components: {
    BasicLayout,
    FederationInfos,
    FederationCategories,
    FederationRegions
  },
  data () {
    return {
      id: this.$route.params.id,
      loadingInfos: true,
      loadingCategories: true,
      loadingRegions: true,
      snackbar: null,
      errorMessage: ''
    }
  },
  computed: {
    federation () {
      return this.$store.state.federations[this.id]
    },
    categories () {
      return this.$store.getters.categoryValues.filter(c => c.federationID === this.id)
    },
    regions () {
      let countryName = this.$country === 'FR' ? 'France' : 'USA'
      return this.$store.getters.regionValues.filter(r => r.name === countryName)
    }
  },
  mounted () {
    this.$store.dispatch('getFederation', this.id)
      .catch(err => {
        console.error(err)
        this.errorMessage = 'Failed to load the federation infos'
        this.snackbar = true
      })
      .then(() => {
        this.loadingInfos = false
      })

    this.$store.dispatch('getFederationCategories', this.id)
      .catch(err => {
        console.error(err)
        this.errorMessage = 'Failed to load federation categories'
        this.snackbar = true
      })
      .then(() => {
        this.loadingCategories = false
      })

    this.$store.dispatch('getFederationRegions', this.id)
      .catch(err => {
        console.error(err)
        this.errorMessage = 'Failed to load federation regions'
        this.snackbar = true
      })
      .then(() => {
        this.loadingRegions = false
      })
  }
}

</script>

<style lang="scss" scoped>

.block {
  margin-top: 30px;
}

</style>



// WEBPACK FOOTER //
// src/pages/federation/Federation.vue